export default __webpack_public_path__ + "static/media/win-prizes-1.6ce8c653.svg";